/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var FormMixin = require('ES/widgets/forms/FormMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var ServicesUtils = require('ES/utils/ServicesUtils');
var SlideOpenDown = require('../../widgets/SlideOpenDown');
var HorizontalFields = require('ES/widgets/HorizontalFields');

module.exports = dd.createClass({
	mixins: [ServicesUtils.RadioAjaxMixin("read_Thirdpartyconnection_Insightly_config", "save_Thirdpartyconnection_Insightly_config")],
	getInitialState: function () {
		return {sid: -1, successMessage: null, failureMessage: null};
	},
	__RadioAjax_key_read_Thirdpartyconnection_Insightly_config: function () {
		return this.state.sid;
	},
	__RadioAjax_key_save_Thirdpartyconnection_Insightly_config: function () {
		return this.state.sid;
	},
	__RadioAjax_read_Thirdpartyconnection_Insightly_config_success: function () {
		this.setState({successMessage: 'API Key saved. You can now grab contacts from Insightly.', failureMessage: null});
	},
	__RadioAjax_read_Thirdpartyconnection_Insightly_config_failure: function (sid, data) {
		this.setState({successMessage: null, failureMessage: data});
	},

	componentWillReceiveProps: function (props) {
		this.__loadForSid(props.selected_sid);
	},
	componentDidMount: function () {
		this.__loadForSid(this.props.selected_sid);
	},
	__loadForSid: function (sid) {
		if (sid !== this.state.sid) {
			this.setState({sid: sid}, function () {
				radio('read_Thirdpartyconnection_Insightly_config').broadcast(sid);
			});
		}
	},
	__onSubmit: function (data) {
		radio('save_Thirdpartyconnection_Insightly_config').broadcast(this.state.sid, data, this.__RadioAjax_read_Thirdpartyconnection_Insightly_config_success, this.__RadioAjax_read_Thirdpartyconnection_Insightly_config_failure);
	},
	render: function () {
		var Displaylists = this.props.Displaylists;

		var sid = this.state.sid;
		var ajax_read = this.state.read_Thirdpartyconnection_Insightly_config; //this doesn't appear to be hooked up
		var ajax_save = this.state.save_Thirdpartyconnection_Insightly_config; //this doesn't appear to be hooked up
		var successMessage = this.state.successMessage;
		var failureMessage = this.state.failureMessage;

		var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
			return spkr.sid == sid;
		}, this);

		return dd.div(null,
			LoadingWrap({
					is_loading: ajax_read.waiting || ajax_save.waiting,
					glass: true
				},
				dd.h3(null,
					'Insightly connector for ',
					dd.span({className: 'nametag'},
						speaker ? speaker.name_full : '')
				),
				dd.p({className: 'text-muted'},
					'NOTE: The settings for this connector is PER-SPEAKER. This change will apply to all users on the account.'
				),
				ErrorAlert({message: ajax_read.error_message}),
				ErrorAlert({message: ajax_save.error_message}),
				ErrorAlert({message: failureMessage}),
				(_.isEmpty(successMessage)) ? null : dd.div({className: 'alert alert-success'},
					successMessage
				),
				DaForm({
					sid: sid,
					config: ajax_read.data,
					onSubmit: this.__onSubmit
				})
			)
		);
	}
});

var DaForm = dd.createClass({
	mixins: [FormMixin],
	getInitialValuesSourceVersion: function (props) {
		return props.sid + JSON.stringify(this.getInitialValues(props));
	},
	getInitialValues: function (props) {
		var config = props.config || {};
		return {
			insightly_api_token: config.insightly_api_token || '',
		};
	},
	buildFields: function () {
		return {
			insightly_api_token: {
				label: 'Insightly API KEY',
				type: 'text',
				help_text: 'example: 08491f242aaa21e013fa56b26c1a9c72',
				tooltip: 'Input the your Insightly API Key. You can find this in Insightly in USER SETTINGS -> API KEY.'
			}
		};
	},
	__discardChanges: esUtils.wrapPreventDefault(function () {
		this._form_reset();
	}),
	render: function () {
		var fields = this.buildFields();
		var errors = this.state.errors || {};
		var changes_made = this._form_areChangesMade();

		return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
			HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}),
			SlideOpenDown({open: changes_made},
				HorizontalFields.FormButtons({onDiscard: this.__discardChanges})
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/account_settings/connect/Insightly.js